export const ConstService = {
    BR_TAG: '<br>',
    LINE_BREAK: '\n',
    ERR: {
      TITLE: {
          NOT_VALID: '',
          SYSTEM_ERROR: 'System error occurred',
      }
    },
    TOAST: {
        TITLE: {
            NOTIFICATION: 'Notification',
            WARN: 'Warning',
        },
        DESCRIPTION: {
            SAVE: 'Save success',
            UPDATE: 'Update success',
            DELETE: 'Delete success',
            RE_SEND_EMAIL: 'Resend email success',
            APRV_RQST: {
                SAVE: 'Your save request has been successfully forwarded to the responsible person.',
                UPDATE: 'Your update request has been successfully forwarded to the responsible person.',
                DELETE: 'Your delete request has been successfully forwarded to the responsible person.',
            }
            , PRJ: {
                NM: 'Please enter project name',
                CATEGORY: 'Please select project category',
                CONNECT_CATEGORY: 'Please select a project to connect',
                DESCRIPTION: 'Please enter project description',
            }
            , ERROR: {
                PRJ_SE_CD: 'Only subprojects can be created'
            }
        }
    },
    localStorage: {
        USER: 'user',
        ACCESS_TOKEN: 'Access Token',
        REDIRECT: 'redirect'
    },
    // TODO
    code: {
        abbr: {
            prj: {
                prjSeCd: {
                    MAIN: { label: 'Main', code: 'MAIN', description: 'Main project category code' },
                    WORD: { label: 'Word', code: 'WORD', description: 'Word project category code' },
                    TERM: { label: 'Term', code: 'TERM', description: 'Term project category code' },
                    DOMAIN: { label: 'Domain', code: 'DOMAIN', description: 'Domain project category code' },
                    DOMAIN_GROUP: { label: 'Domain Group', code: 'DOMAIN_GROUP', description: 'Domain Group project category code' },
                    DOMAIN_CATEGORY: { label: 'Domain Category', code: 'DOMAIN_CATEGORY', description: 'Domain category project category code' },
                },
                subPrjSeCd: {
                    WORD: { label: 'Word', code: 'WORD', description: 'Word project category code' },
                    TERM: { label: 'Term', code: 'TERM', description: 'Term project category code' },
                    DOMAIN: { label: 'Domain', code: 'DOMAIN', description: 'Domain project category code' },
                    DOMAIN_GROUP: { label: 'Domain Group', code: 'DOMAIN_GROUP', description: 'Domain Group project category code' },
                    DOMAIN_CATEGORY: { label: 'Domain Category', code: 'DOMAIN_CATEGORY', description: 'Domain category project category code' },
                }
            }
        }
    },
    list: {
        abbr: {
            prj: {
                prjSeCd: () => {
                    return Object.keys(ConstService.code.abbr.prj.prjSeCd);
                },
                subPrjSeCd: () => {
                    return Object.keys(ConstService.code.abbr.prj.subPrjSeCd);
                },
            }
        }
    },
    dropdown: {
        abbr: {
          prj: {
              mbrSttsCd: [
                { label: 'Normal', code: 'N' },
                { label: 'Block', code: 'B' },
                { label: 'Request', code: 'R' }
              ],
              prjSeCd: () => {
                  return convertCodeToDropdownList(ConstService.code.abbr.prj.prjSeCd);
              },
              subPrjSeCd: () => {
                  return convertCodeToDropdownList(ConstService.code.abbr.prj.subPrjSeCd);
              },
              roleId: [
                  { label: 'Owner', code: 'OWNER' },
                  { label: 'Manager', code: 'MANAGER' },
                  { label: 'Participant', code: 'PARTICIPANT' }
              ]
              , dataTypeCd: [
                  { code: "CHAR", label: "Char" },
                  { code: "VARCHAR", label: "Varchar" },
                  { code: "TEXT", label: "Text" },
                  { code: "INT", label: "Int" },
                  { code: "BIGINT", label: "BigInt" },
                  { code: "FLOAT", label: "Float" },
                  { code: "DOUBLE", label: "Double" },
                  { code: "DATE", label: "Date" },
                  { code: "DATETIME", label: "DateTime" },
                  { code: "TIMESTAMP", label: "Timestamp" },
                  { code: "BOOLEAN", label: "Boolean" }
              ]
              , stdDmnCtgryCd: [
                  { label: "Price", code: "PRICE" },
                  { label: "Amount", code: "AMOUNT" },
                  { label: "Cost", code: "COST" },
                  { label: "Fee", code: "FEE" },
                  { label: "HourMinute", code: "HH24MI" },
                  { label: "HourMinuteSecond", code: "HH24MISS" },
                  { label: "Year", code: "YYYY" },
                  { label: "YearMonth", code: "YYYYMM" },
                  { label: "YearMonthDay", code: "YYYYMMDD" },
                  { label: "YearMonthDayHourMinute", code: "YYYYMMDDHH24MI" },
                  { label: "YearMonthDayHourMinuteSecond", code: "YYYYMMDDHH24MISS" },
                  { label: "Month", code: "MM" },
                  { label: "Content", code: "CONTENT" },
                  { label: "Name", code: "NAME" },
                  { label: "DetailedAddress", code: "DETAILED_ADDRESS" },
                  { label: "Address", code: "ADDRESS" },
                  { label: "BuildingNumber", code: "BUILDING_NUMBER" },
                  { label: "BuildingMainNumber", code: "BUILDING_MAIN_NUMBER" },
                  { label: "BuildingSubNumber", code: "BUILDING_SUB_NUMBER" },
                  { label: "AccountNumber", code: "ACCOUNT_NUMBER" },
                  { label: "OldPostalCode", code: "OLD_POSTAL_CODE" },
                  { label: "Number", code: "NUMBER" },
                  { label: "CorporateRegistrationNumber", code: "CORPORATE_REGISTRATION_NUMBER" },
                  { label: "MainNumber", code: "MAIN_NUMBER" },
                  { label: "SubNumber", code: "SUB_NUMBER" },
                  { label: "BusinessRegistrationNumber", code: "BUSINESS_REGISTRATION_NUMBER" },
                  { label: "CreditCardNumber", code: "CREDIT_CARD_NUMBER" },
                  { label: "PassportNumber", code: "PASSPORT_NUMBER" },
                  { label: "ForeignerRegistrationNumber", code: "FOREIGNER_REGISTRATION_NUMBER" },
                  { label: "PostalCode", code: "POSTAL_CODE" },
                  { label: "Driver'sLicenseNumber", code: "DRIVERS_LICENSE_NUMBER" },
                  { label: "SerialNumber", code: "SERIAL_NUMBER" },
                  { label: "CarRegistrationNumber", code: "CAR_REGISTRATION_NUMBER" },
                  { label: "ElectronicPaymentNumber", code: "ELECTRONIC_PAYMENT_NUMBER" },
                  { label: "PhoneNumber", code: "PHONE_NUMBER" },
                  { label: "ResidentRegistrationNumber", code: "RESIDENT_REGISTRATION_NUMBER" },
                  { label: "VehicleIdentificationNumber", code: "VEHICLE_IDENTIFICATION_NUMBER" },
                  { label: "FaxNumber", code: "FAX_NUMBER" },
                  { label: "Longitude", code: "LONGITUDE" },
                  { label: "Area", code: "AREA" },
                  { label: "Quantity", code: "QUANTITY" },
                  { label: "Order", code: "ORDER" },
                  { label: "Latitude", code: "LATITUDE" },
                  { label: "Coordinates", code: "COORDINATE" },
                  { label: "Rate", code: "RATE" },
                  { label: "Code", code: "CODE" },
                  { label: "Status", code: "STATUS" }
              ]
          }
        },
        useYN: [
            { label: 'Yes', code: 'Y' },
            { label: 'No', code: 'N' }
        ],
        db: [
            {label: 'MariaDB', code: 'MARIADB'},
            {label: 'MySQL', code: 'MYSQL'},
            {label: 'Oracle', code: 'ORACLE'},
        ],
        ga: {
            prj: {
                prjKndDcd: [
                    {code: '01', label: '정규예산'},
                    {code: '02', label: '추가예산'},
                    {code: '03', label: '프로젝트예산'}
                ],
                prjPgsgDcd: [
                    {code: '01', label: '책임자승인 진행중'},
                    {code: '02', label: '프로젝트 진행중'},
                    {code: '03', label: '완료'}
                ]
            }
        },
        countries: [
            { label: 'Afghanistan', code: 'AF' },
            { label: 'Albania', code: 'AL' },
            { label: 'Algeria', code: 'DZ' },
            { label: 'American Samoa', code: 'AS' },
            { label: 'Andorra', code: 'AD' },
            { label: 'Angola', code: 'AO' },
            { label: 'Anguilla', code: 'AI' },
            { label: 'Antarctica', code: 'AQ' },
            { label: 'Antigua and Barbuda', code: 'AG' },
            { label: 'Argentina', code: 'AR' },
            { label: 'Armenia', code: 'AM' },
            { label: 'Aruba', code: 'AW' },
            { label: 'Australia', code: 'AU' },
            { label: 'Austria', code: 'AT' },
            { label: 'Azerbaijan', code: 'AZ' },
            { label: 'Bahamas', code: 'BS' },
            { label: 'Bahrain', code: 'BH' },
            { label: 'Bangladesh', code: 'BD' },
            { label: 'Barbados', code: 'BB' },
            { label: 'Belarus', code: 'BY' },
            { label: 'Belgium', code: 'BE' },
            { label: 'Belize', code: 'BZ' },
            { label: 'Benin', code: 'BJ' },
            { label: 'Bermuda', code: 'BM' },
            { label: 'Bhutan', code: 'BT' },
            { label: 'Bolivia', code: 'BO' },
            { label: 'Bosnia and Herzegovina', code: 'BA' },
            { label: 'Botswana', code: 'BW' },
            { label: 'Bouvet Island', code: 'BV' },
            { label: 'Brazil', code: 'BR' },
            { label: 'British Indian Ocean Territory', code: 'IO' },
            { label: 'Brunei Darussalam', code: 'BN' },
            { label: 'Bulgaria', code: 'BG' },
            { label: 'Burkina Faso', code: 'BF' },
            { label: 'Burundi', code: 'BI' },
            { label: 'Cambodia', code: 'KH' },
            { label: 'Cameroon', code: 'CM' },
            { label: 'Canada', code: 'CA' },
            { label: 'Cape Verde', code: 'CV' },
            { label: 'Cayman Islands', code: 'KY' },
            { label: 'Central African Republic', code: 'CF' },
            { label: 'Chad', code: 'TD' },
            { label: 'Chile', code: 'CL' },
            { label: 'China', code: 'CN' },
            { label: 'Christmas Island', code: 'CX' },
            { label: 'Cocos (Keeling) Islands', code: 'CC' },
            { label: 'Colombia', code: 'CO' },
            { label: 'Comoros', code: 'KM' },
            { label: 'Congo', code: 'CG' },
            { label: 'Congo, The Democratic Republic of the', code: 'CD' },
            { label: 'Cook Islands', code: 'CK' },
            { label: 'Costa Rica', code: 'CR' },
            { label: 'Cote D"Ivoire', code: 'CI' },
            { label: 'Croatia', code: 'HR' },
            { label: 'Cuba', code: 'CU' },
            { label: 'Cyprus', code: 'CY' },
            { label: 'Czech Republic', code: 'CZ' },
            { label: 'Denmark', code: 'DK' },
            { label: 'Djibouti', code: 'DJ' },
            { label: 'Dominica', code: 'DM' },
            { label: 'Dominican Republic', code: 'DO' },
            { label: 'Ecuador', code: 'EC' },
            { label: 'Egypt', code: 'EG' },
            { label: 'El Salvador', code: 'SV' },
            { label: 'Equatorial Guinea', code: 'GQ' },
            { label: 'Eritrea', code: 'ER' },
            { label: 'Estonia', code: 'EE' },
            { label: 'Ethiopia', code: 'ET' },
            { label: 'Falkland Islands (Malvinas)', code: 'FK' },
            { label: 'Faroe Islands', code: 'FO' },
            { label: 'Fiji', code: 'FJ' },
            { label: 'Finland', code: 'FI' },
            { label: 'France', code: 'FR' },
            { label: 'French Guiana', code: 'GF' },
            { label: 'French Polynesia', code: 'PF' },
            { label: 'French Southern Territories', code: 'TF' },
            { label: 'Gabon', code: 'GA' },
            { label: 'Gambia', code: 'GM' },
            { label: 'Georgia', code: 'GE' },
            { label: 'Germany', code: 'DE' },
            { label: 'Ghana', code: 'GH' },
            { label: 'Gibraltar', code: 'GI' },
            { label: 'Greece', code: 'GR' },
            { label: 'Greenland', code: 'GL' },
            { label: 'Grenada', code: 'GD' },
            { label: 'Guadeloupe', code: 'GP' },
            { label: 'Guam', code: 'GU' },
            { label: 'Guatemala', code: 'GT' },
            { label: 'Guernsey', code: 'GG' },
            { label: 'Guinea', code: 'GN' },
            { label: 'Guinea-Bissau', code: 'GW' },
            { label: 'Guyana', code: 'GY' },
            { label: 'Haiti', code: 'HT' },
            { label: 'Heard Island and Mcdonald Islands', code: 'HM' },
            { label: 'Holy See (Vatican City State)', code: 'VA' },
            { label: 'Honduras', code: 'HN' },
            { label: 'Hong Kong', code: 'HK' },
            { label: 'Hungary', code: 'HU' },
            { label: 'Iceland', code: 'IS' },
            { label: 'India', code: 'IN' },
            { label: 'Indonesia', code: 'ID' },
            { label: 'Iran, Islamic Republic Of', code: 'IR' },
            { label: 'Iraq', code: 'IQ' },
            { label: 'Ireland', code: 'IE' },
            { label: 'Isle of Man', code: 'IM' },
            { label: 'Israel', code: 'IL' },
            { label: 'Italy', code: 'IT' },
            { label: 'Jamaica', code: 'JM' },
            { label: 'Japan', code: 'JP' },
            { label: 'Jersey', code: 'JE' },
            { label: 'Jordan', code: 'JO' },
            { label: 'Kazakhstan', code: 'KZ' },
            { label: 'Kenya', code: 'KE' },
            { label: 'Kiribati', code: 'KI' },
            { label: 'Korea, Republic of', code: 'KR' },
            { label: 'Kuwait', code: 'KW' },
            { label: 'Kyrgyzstan', code: 'KG' },
            { label: 'Lao People"S Democratic Republic', code: 'LA' },
            { label: 'Latvia', code: 'LV' },
            { label: 'Lebanon', code: 'LB' },
            { label: 'Lesotho', code: 'LS' },
            { label: 'Liberia', code: 'LR' },
            { label: 'Libyan Arab Jamahiriya', code: 'LY' },
            { label: 'Liechtenstein', code: 'LI' },
            { label: 'Lithuania', code: 'LT' },
            { label: 'Luxembourg', code: 'LU' },
            { label: 'Macao', code: 'MO' },
            { label: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
            { label: 'Madagascar', code: 'MG' },
            { label: 'Malawi', code: 'MW' },
            { label: 'Malaysia', code: 'MY' },
            { label: 'Maldives', code: 'MV' },
            { label: 'Mali', code: 'ML' },
            { label: 'Malta', code: 'MT' },
            { label: 'Marshall Islands', code: 'MH' },
            { label: 'Martinique', code: 'MQ' },
            { label: 'Mauritania', code: 'MR' },
            { label: 'Mauritius', code: 'MU' },
            { label: 'Mayotte', code: 'YT' },
            { label: 'Mexico', code: 'MX' },
            { label: 'Micronesia, Federated States of', code: 'FM' },
            { label: 'Moldova, Republic of', code: 'MD' },
            { label: 'Monaco', code: 'MC' },
            { label: 'Mongolia', code: 'MN' },
            { label: 'Montserrat', code: 'MS' },
            { label: 'Morocco', code: 'MA' },
            { label: 'Mozambique', code: 'MZ' },
            { label: 'Myanmar', code: 'MM' },
            { label: 'Namibia', code: 'NA' },
            { label: 'Nauru', code: 'NR' },
            { label: 'Nepal', code: 'NP' },
            { label: 'Netherlands', code: 'NL' },
            { label: 'Netherlands Antilles', code: 'AN' },
            { label: 'New Caledonia', code: 'NC' },
            { label: 'New Zealand', code: 'NZ' },
            { label: 'Nicaragua', code: 'NI' },
            { label: 'Niger', code: 'NE' },
            { label: 'Nigeria', code: 'NG' },
            { label: 'Niue', code: 'NU' },
            { label: 'Norfolk Island', code: 'NF' },
            { label: 'Northern Mariana Islands', code: 'MP' },
            { label: 'Norway', code: 'NO' },
            { label: 'Oman', code: 'OM' },
            { label: 'Pakistan', code: 'PK' },
            { label: 'Palau', code: 'PW' },
            { label: 'Palestinian Territory, Occupied', code: 'PS' },
            { label: 'Panama', code: 'PA' },
            { label: 'Papua New Guinea', code: 'PG' },
            { label: 'Paraguay', code: 'PY' },
            { label: 'Peru', code: 'PE' },
            { label: 'Philippines', code: 'PH' },
            { label: 'Pitcairn', code: 'PN' },
            { label: 'Poland', code: 'PL' },
            { label: 'Portugal', code: 'PT' },
            { label: 'Puerto Rico', code: 'PR' },
            { label: 'Qatar', code: 'QA' },
            { label: 'Reunion', code: 'RE' },
            { label: 'Romania', code: 'RO' },
            { label: 'Russian Federation', code: 'RU' },
            { label: 'RWANDA', code: 'RW' },
            { label: 'Saint Helena', code: 'SH' },
            { label: 'Saint Kitts and Nevis', code: 'KN' },
            { label: 'Saint Lucia', code: 'LC' },
            { label: 'Saint Pierre and Miquelon', code: 'PM' },
            { label: 'Saint Vincent and the Grenadines', code: 'VC' },
            { label: 'Samoa', code: 'WS' },
            { label: 'San Marino', code: 'SM' },
            { label: 'Sao Tome and Principe', code: 'ST' },
            { label: 'Saudi Arabia', code: 'SA' },
            { label: 'Senegal', code: 'SN' },
            { label: 'Serbia and Montenegro', code: 'CS' },
            { label: 'Seychelles', code: 'SC' },
            { label: 'Sierra Leone', code: 'SL' },
            { label: 'Singapore', code: 'SG' },
            { label: 'Slovakia', code: 'SK' },
            { label: 'Slovenia', code: 'SI' },
            { label: 'Solomon Islands', code: 'SB' },
            { label: 'Somalia', code: 'SO' },
            { label: 'South Africa', code: 'ZA' },
            { label: 'South Georgia and the South Sandwich Islands', code: 'GS' },
            { label: 'Spain', code: 'ES' },
            { label: 'Sri Lanka', code: 'LK' },
            { label: 'Sudan', code: 'SD' },
            { label: 'Suriname', code: 'SR' },
            { label: 'Svalbard and Jan Mayen', code: 'SJ' },
            { label: 'Swaziland', code: 'SZ' },
            { label: 'Sweden', code: 'SE' },
            { label: 'Switzerland', code: 'CH' },
            { label: 'Syrian Arab Republic', code: 'SY' },
            { label: 'Taiwan, Province of China', code: 'TW' },
            { label: 'Tajikistan', code: 'TJ' },
            { label: 'Tanzania, United Republic of', code: 'TZ' },
            { label: 'Thailand', code: 'TH' },
            { label: 'Timor-Leste', code: 'TL' },
            { label: 'Togo', code: 'TG' },
            { label: 'Tokelau', code: 'TK' },
            { label: 'Tonga', code: 'TO' },
            { label: 'Trinidad and Tobago', code: 'TT' },
            { label: 'Tunisia', code: 'TN' },
            { label: 'Turkey', code: 'TR' },
            { label: 'Turkmenistan', code: 'TM' },
            { label: 'Turks and Caicos Islands', code: 'TC' },
            { label: 'Tuvalu', code: 'TV' },
            { label: 'Uganda', code: 'UG' },
            { label: 'Ukraine', code: 'UA' },
            { label: 'United Arab Emirates', code: 'AE' },
            { label: 'United Kingdom', code: 'GB' },
            { label: 'United States', code: 'US' },
            { label: 'United States Minor Outlying Islands', code: 'UM' },
            { label: 'Uruguay', code: 'UY' },
            { label: 'Uzbekistan', code: 'UZ' },
            { label: 'Vanuatu', code: 'VU' },
            { label: 'Venezuela', code: 'VE' },
            { label: 'Viet Nam', code: 'VN' },
            { label: 'Virgin Islands, British', code: 'VG' },
            { label: 'Virgin Islands, U.S.', code: 'VI' },
            { label: 'Wallis and Futuna', code: 'WF' },
            { label: 'Western Sahara', code: 'EH' },
            { label: 'Yemen', code: 'YE' },
            { label: 'Zambia', code: 'ZM' },
            { label: 'Zimbabwe', code: 'ZW' }
        ],
        languages: [
            { code: 'aa', label: 'Afar' },
            { code: 'ab', label: 'Abkhazian' },
            { code: 'af', label: 'Afrikaans' },
            { code: 'ak', label: 'Akan' },
            { code: 'am', label: 'Amharic' },
            { code: 'ar', label: 'Arabic' },
            { code: 'an', label: 'Aragonese' },
            { code: 'as', label: 'Assamese' },
            { code: 'av', label: 'Avaric' },
            { code: 'ae', label: 'Avestan' },
            { code: 'ay', label: 'Aymara' },
            { code: 'az', label: 'Azerbaijani' },
            { code: 'ba', label: 'Bashkir' },
            { code: 'bm', label: 'Bambara' },
            { code: 'be', label: 'Belarusian' },
            { code: 'bn', label: 'Bengali' },
            { code: 'bh', label: 'Bihari languages' },
            { code: 'bi', label: 'Bislama' },
            { code: 'bs', label: 'Bosnian' },
            { code: 'br', label: 'Breton' },
            { code: 'bg', label: 'Bulgarian' },
            { code: 'ca', label: 'Catalan' },
            { code: 'ch', label: 'Chamorro' },
            { code: 'ce', label: 'Chechen' },
            { code: 'zh', label: 'Chinese' },
            { code: 'cu', label: 'Church Slavic' },
            { code: 'cv', label: 'Chuvash' },
            { code: 'kw', label: 'Cornish' },
            { code: 'co', label: 'Corsican' },
            { code: 'cr', label: 'Cree' },
            { code: 'cs', label: 'Czech' },
            { code: 'da', label: 'Danish' },
            { code: 'dv', label: 'Divehi' },
            { code: 'nl', label: 'Dutch' },
            { code: 'dz', label: 'Dzongkha' },
            { code: 'en', label: 'English' },
            { code: 'eo', label: 'Esperanto' },
            { code: 'et', label: 'Estonian' },
            { code: 'ee', label: 'Ewe' },
            { code: 'fo', label: 'Faroese' },
            { code: 'fj', label: 'Fijian' },
            { code: 'fi', label: 'Finnish' },
            { code: 'fr', label: 'French' },
            { code: 'fy', label: 'Western Frisian' },
            { code: 'ff', label: 'Fulah' },
            { code: 'gd', label: 'Gaelic' },
            { code: 'gl', label: 'Galician' },
            { code: 'lg', label: 'Ganda' },
            { code: 'ka', label: 'Georgian' },
            { code: 'de', label: 'German' },
            { code: 'el', label: 'Greek' },
            { code: 'gn', label: 'Guarani' },
            { code: 'gu', label: 'Gujarati' },
            { code: 'ht', label: 'Haitian' },
            { code: 'ha', label: 'Hausa' },
            { code: 'he', label: 'Hebrew' },
            { code: 'hz', label: 'Herero' },
            { code: 'hi', label: 'Hindi' },
            { code: 'ho', label: 'Hiri Motu' },
            { code: 'hr', label: 'Croatian' },
            { code: 'hu', label: 'Hungarian' },
            { code: 'hy', label: 'Armenian' },
            { code: 'ig', label: 'Igbo' },
            { code: 'is', label: 'Icelandic' },
            { code: 'io', label: 'Ido' },
            { code: 'ii', label: 'Sichuan Yi' },
            { code: 'iu', label: 'Inuktitut' },
            { code: 'ie', label: 'Interlingue' },
            { code: 'ia', label: 'Interlingua' },
            { code: 'id', label: 'Indonesian' },
            { code: 'ik', label: 'Inupiaq' },
            { code: 'it', label: 'Italian' },
            { code: 'jv', label: 'Javanese' },
            { code: 'ja', label: 'Japanese' },
            { code: 'kl', label: 'Kalaallisut' },
            { code: 'kn', label: 'Kannada' },
            { code: 'ks', label: 'Kashmiri' },
            { code: 'kr', label: 'Kanuri' },
            { code: 'kk', label: 'Kazakh' },
            { code: 'km', label: 'Central Khmer' },
            { code: 'ki', label: 'Kikuyu' },
            { code: 'rw', label: 'Kinyarwanda' },
            { code: 'ky', label: 'Kirghiz' },
            { code: 'kv', label: 'Komi' },
            { code: 'kg', label: 'Kongo' },
            { code: 'ko', label: 'Korean' },
            { code: 'kj', label: 'Kuanyama' },
            { code: 'ku', label: 'Kurdish' },
            { code: 'lo', label: 'Lao' },
            { code: 'la', label: 'Latin' },
            { code: 'lv', label: 'Latvian' },
            { code: 'li', label: 'Limburgan' },
            { code: 'ln', label: 'Lingala' },
            { code: 'lt', label: 'Lithuanian' },
            { code: 'lb', label: 'Luxembourgish' },
            { code: 'lu', label: 'Luba-Katanga' },
            { code: 'mk', label: 'Macedonian' },
            { code: 'mg', label: 'Malagasy' },
            { code: 'ms', label: 'Malay' },
            { code: 'ml', label: 'Malayalam' },
            { code: 'mt', label: 'Maltese' },
            { code: 'gv', label: 'Manx' },
            { code: 'mi', label: 'Maori' },
            { code: 'mr', label: 'Marathi' },
            { code: 'mh', label: 'Marshallese' },
            { code: 'mn', label: 'Mongolian' },
            { code: 'na', label: 'Nauru' },
            { code: 'nv', label: 'Navajo' },
            { code: 'ng', label: 'Ndonga' },
            { code: 'ne', label: 'Nepali' },
            { code: 'nd', label: 'North Ndebele' },
            { code: 'se', label: 'Northern Sami' },
            { code: 'no', label: 'Norwegian' },
            { code: 'nb', label: 'Norwegian Bokmål' },
            { code: 'nn', label: 'Norwegian Nynorsk' },
            { code: 'ny', label: 'Nyanja' },
            { code: 'oc', label: 'Occitan' },
            { code: 'oj', label: 'Ojibwa' },
            { code: 'or', label: 'Oriya' },
            { code: 'om', label: 'Oromo' },
            { code: 'os', label: 'Ossetian' },
            { code: 'pa', label: 'Panjabi' },
            { code: 'fa', label: 'Persian' },
            { code: 'pi', label: 'Pali' },
            { code: 'pl', label: 'Polish' },
            { code: 'pt', label: 'Portuguese' },
            { code: 'ps', label: 'Pushto' },
            { code: 'qu', label: 'Quechua' },
            { code: 'rm', label: 'Romansh' },
            { code: 'ro', label: 'Romanian' },
            { code: 'rn', label: 'Rundi' },
            { code: 'ru', label: 'Russian' },
            { code: 'sg', label: 'Sango' },
            { code: 'sa', label: 'Sanskrit' },
            { code: 'si', label: 'Sinhala' },
            { code: 'sk', label: 'Slovak' },
            { code: 'sl', label: 'Slovenian' },
            { code: 'sm', label: 'Samoan' },
            { code: 'sn', label: 'Shona' },
            { code: 'sd', label: 'Sindhi' },
            { code: 'so', label: 'Somali' },
            { code: 'st', label: 'Sotho, Southern' },
            { code: 'es', label: 'Spanish' },
            { code: 'sc', label: 'Sardinian' },
            { code: 'sr', label: 'Serbian' },
            { code: 'ss', label: 'Swati' },
            { code: 'su', label: 'Sundanese' },
            { code: 'sw', label: 'Swahili' },
            { code: 'sv', label: 'Swedish' },
            { code: 'ty', label: 'Tahitian' },
            { code: 'ta', label: 'Tamil' },
            { code: 'tt', label: 'Tatar' },
            { code: 'te', label: 'Telugu' },
            { code: 'tg', label: 'Tajik' },
            { code: 'tl', label: 'Tagalog' },
            { code: 'th', label: 'Thai' },
            { code: 'ti', label: 'Tigrinya' },
            { code: 'to', label: 'Tonga (Tonga Islands)' },
            { code: 'tn', label: 'Tswana' },
            { code: 'ts', label: 'Tsonga' },
            { code: 'tk', label: 'Turkmen' },
            { code: 'tr', label: 'Turkish' },
            { code: 'tw', label: 'Twi' },
            { code: 'ug', label: 'Uighur' },
            { code: 'uk', label: 'Ukrainian' },
            { code: 'ur', label: 'Urdu' },
            { code: 'uz', label: 'Uzbek' },
            { code: 've', label: 'Venda' },
            { code: 'vi', label: 'Vietnamese' },
            { code: 'vo', label: 'Volapük' },
            { code: 'wa', label: 'Walloon' },
            { code: 'cy', label: 'Welsh' },
            { code: 'wo', label: 'Wolof' },
            { code: 'xh', label: 'Xhosa' },
            { code: 'yi', label: 'Yiddish' },
            { code: 'yo', label: 'Yoruba' },
            { code: 'za', label: 'Zhuang' },
            { code: 'zu', label: 'Zulu' }
        ]
    }
    , logo: {
        full: '/assets/img/logo/CoreDiTech_Logo(Logo_Text(Right)).png',
        onlyLogo: '/assets/img/logo/CoreDiTech_Logo.png',
    }
};

function convertCodeToDropdownList(codeObjects) {

    return Object.keys(codeObjects).map(key => {
        const { label, code } = codeObjects[key];
        return { label, code };
    });
}
